import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { usStatesEnumSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { healthPlanAvailabilitySchema } from "./schemas";

const c = initContract();

export const healthPlansContract = c.router({
  getHealthPlanAvailability: {
    summary: "Get the number of health plans available for a given US state",
    method: "GET",
    path: "/health-plans/availability",
    query: z.object({
      usState: usStatesEnumSchema,
    }),
    responses: {
      [HTTPStatusCode.OK]: healthPlanAvailabilitySchema,
    },
  },
});
